module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('vue-progress-bar'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticStyle: {
      "margin-top": "-10px"
    }
  }, [_c('v-card-title', [_c('v-text-field', {
    staticStyle: {
      "width": "100px",
      "margin-top": "-20px",
      "margin-left": "20px"
    },
    attrs: {
      "append-icon": "search",
      "label": "Quick Search",
      "single-line": "",
      "hide-details": "",
      "clearable": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('form', {
    attrs: {
      "enctype": "multipart/form-data",
      "novalidate": ""
    }
  }, [_c('div', {
    class: !_vm.dark ? 'dropbox dropbox-light' : 'dropbox'
  }, [_c('input', {
    ref: "fileInput",
    staticClass: "input-file",
    attrs: {
      "type": "file",
      "name": _vm.uploadFieldName,
      "disabled": _vm.isSaving,
      "accept": "*.pdf"
    },
    on: {
      "change": function($event) {
        _vm.filesChange($event.target.name, $event.target.files);
        _vm.fileCount = $event.target.files.length
      }
    }
  }), _vm._v(" "), (_vm.isInitial) ? _c('p', [_vm._v("\n            Для проверки перетяните сюда pdf файл"), _c('br'), _vm._v(" или кликните для выбора\n          ")]) : _vm._e(), _vm._v(" "), (_vm.isSuccess) ? _c('p', {
    staticStyle: {
      "font-size": "20px",
      "font-weight": "bold",
      "color": "black"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.result) + "    \n            "), _c('v-btn', {
    staticClass: "grey",
    staticStyle: {
      "margin-top": "-0px"
    },
    attrs: {
      "fab": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.reset()
      }
    }
  }, [_c('v-icon', [_vm._v("cancel")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isSaving) ? _c('p', [_vm._v("\n            Выполняется проверка...\n          ")]) : _vm._e()])]), _vm._v(" "), (_vm.isFailed) ? _c('div', [_c('h2', [_vm._v("Uploaded failed.")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.reset()
      }
    }
  }, [_vm._v("Try again")])])]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "brown lighten-1",
    attrs: {
      "fab": "",
      "small": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.reloadData()
      }
    }
  }, [_c('v-icon', [_vm._v("refresh")])], 1), _vm._v(" "), _c('table', [_c('v-btn', {
    staticClass: "grey",
    staticStyle: {
      "font-size": "8px"
    },
    attrs: {
      "fab": "",
      "small": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.getJSON()
      }
    }
  }, [_vm._v("\n              JSON\n            ")])], 1)], 1), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1",
    staticStyle: {
      "white-space": "nowrap",
      "margin-top": "-10px"
    },
    attrs: {
      "headers": _vm.headers,
      "items": _vm.items,
      "search": _vm.search,
      "pagination": _vm.pagination,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "headers",
      fn: function(props) {
        return [_c('tr', [_c('th', {
          staticStyle: {
            "max-width": "30px"
          }
        }, [_vm._v("ID проверки")]), _vm._v(" "), _c('th', {
          staticStyle: {
            "max-width": "30px"
          }
        }, [_vm._v("Сотрудник")]), _vm._v(" "), _c('th', {
          staticStyle: {
            "max-width": "30px"
          }
        }, [_vm._v("Вес файла")]), _vm._v(" "), _c('th', {
          staticStyle: {
            "max-width": "30px"
          }
        }, [_vm._v("Отправитель")]), _vm._v(" "), _c('th', {
          staticStyle: {
            "max-width": "30px"
          }
        }, [_vm._v("Получатель")]), _vm._v(" "), _c('th', {
          staticStyle: {
            "max-width": "30px"
          }
        }, [_vm._v("Сумма")]), _vm._v(" "), _c('th', {
          staticStyle: {
            "max-width": "30px"
          }
        }, [_vm._v("Время платежа")]), _vm._v(" "), _c('th', {
          staticStyle: {
            "max-width": "30px"
          }
        }, [_vm._v("Время проверки")]), _vm._v(" "), _c('th', {
          staticStyle: {
            "max-width": "30px"
          }
        }, [_vm._v("Чек")])])]
      }
    }, {
      key: "items",
      fn: function(props) {
        return [_c('td', {
          attrs: {
            "width": "80"
          }
        }, [_vm._v(_vm._s(props.item.id) + " " + _vm._s(props.item.result == 1 ? "✅" : "❌") + " \n            "), _c('span', {
          staticStyle: {
            "font-size": "1.5em"
          }
        }, [_vm._v(" " + _vm._s(props.item.mail_check === 0 ? '📧' : '') + " ")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.nick_name))]), _vm._v(" "), _c('td', {
          staticStyle: {
            "max-width": "30px"
          }
        }, [_vm._v(_vm._s(props.item.file_size))]), _vm._v(" "), _c('td', {
          staticStyle: {
            "max-width": "170px"
          }
        }, [_vm._v(_vm._s(_vm.renderSender(props.item)) + " "), _c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.banksKeys[props.item.bank]))])]), _vm._v(" "), _c('td', {
          staticStyle: {
            "max-width": "170px"
          }
        }, [_vm._v(_vm._s(_vm.renderRemitte(props.item))), _c('br'), _c('b', [_vm._v(_vm._s(props.item.receiver_bank))])]), _vm._v(" "), _c('td', {
          staticStyle: {
            "max-width": "50px"
          }
        }, [_vm._v(_vm._s(props.item.sum))]), _vm._v(" "), _c('td', {
          staticStyle: {
            "max-width": "110px"
          }
        }, [_vm._v(_vm._s(props.item.payment_time))]), _vm._v(" "), _c('td', {
          staticStyle: {
            "max-width": "110px"
          }
        }, [_vm._v(_vm._s(props.item.timestamp))]), _vm._v(" "), _c('td', {
          staticStyle: {
            "max-width": "40px"
          }
        }, [_c('a', {
          attrs: {
            "href": 'https://desk.bankpdf.ru/uploads/' + props.item.file + '.pdf',
            "target": "_blank"
          }
        }, [_vm._v("Открыть")])]), _vm._v(" "), _c('td', {
          staticStyle: {
            "max-width": "50px"
          }
        }, [_c('v-btn', {
          staticClass: "grey",
          staticStyle: {
            "font-size": "8px"
          },
          attrs: {
            "fab": "",
            "small": "",
            "flat": ""
          },
          nativeOn: {
            "click": function($event) {
              _vm.cancel(props.item.id)
            }
          }
        }, [_c('v-icon', [_vm._v("cancel")])], 1)], 1)]
      }
    }])
  }, [_c('template', {
    slot: "no-data"
  }, [_c('span', [_c('p', {
    staticClass: "pt-2 blue--text subheading"
  }, [_c('v-icon', {
    staticClass: "blue--text",
    attrs: {
      "medium": ""
    }
  }, [_vm._v("info")]), _vm._v("Sorry, nothing to display here :(")], 1)])])], 2), _vm._v(" "), (_vm.isNotEmpty) ? _c('div', {
    staticClass: "text-xs-center pt-2"
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.pagination.pages,
      "total-visible": 10,
      "circle": ""
    },
    model: {
      value: (_vm.pagination.page),
      callback: function($$v) {
        _vm.$set(_vm.pagination, "page", $$v)
      },
      expression: "pagination.page"
    }
  })], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /Users/gtirby/develop/~/vue-loader/lib/template-compiler?{"id":"data-v-41d95bf3","hasScoped":true}!/Users/gtirby/develop/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PDFChecks.vue
// module id = 416
// module chunks = 0